module.exports = __webpack_public_path__ + "img/67.5.COD.1ccb43d8.png";